import React, { Component } from 'react';

class Settings extends Component {
  render() {
    return (
      <h2 data-testid="settings-title">Configurações</h2>
    );
  }
}

export default Settings;
